/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyInvitationResource } from './';
import {
    ClientCompanyInvitationResourceFromJSON,
    ClientCompanyInvitationResourceFromJSONTyped,
    ClientCompanyInvitationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface PageClientCompanyInvitationResource
 */
export interface PageClientCompanyInvitationResource {
    /**
     * 
     * @type {Array<ClientCompanyInvitationResource>}
     * @memberof PageClientCompanyInvitationResource
     */
    content?: Array<ClientCompanyInvitationResource>;
    /**
     * The total number of elements (not considering pagination)
     * @type {number}
     * @memberof PageClientCompanyInvitationResource
     */
    totalElements: number;
    /**
     * True if the current page is the first page
     * @type {boolean}
     * @memberof PageClientCompanyInvitationResource
     */
    first: boolean;
    /**
     * True if the current page is the last available page
     * @type {boolean}
     * @memberof PageClientCompanyInvitationResource
     */
    last: boolean;
    /**
     * The number of elements of the current page (at most the page size)
     * @type {number}
     * @memberof PageClientCompanyInvitationResource
     */
    numberOfElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageClientCompanyInvitationResource
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the PageClientCompanyInvitationResource interface.
 */
export function instanceOfPageClientCompanyInvitationResource(value: object): value is PageClientCompanyInvitationResource {
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('first' in value) || value['first'] === undefined) return false;
    if (!('last' in value) || value['last'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    return true;
}

export function PageClientCompanyInvitationResourceFromJSON(json: any): PageClientCompanyInvitationResource {
    return PageClientCompanyInvitationResourceFromJSONTyped(json, false);
}

export function PageClientCompanyInvitationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageClientCompanyInvitationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ClientCompanyInvitationResourceFromJSON)),
        'totalElements': json['totalElements'],
        'first': json['first'],
        'last': json['last'],
        'numberOfElements': json['numberOfElements'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function PageClientCompanyInvitationResourceToJSON(value?: PageClientCompanyInvitationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map((v) => ClientCompanyInvitationResourceToJSON(v))),
        'totalElements': value['totalElements'],
        'first': value['first'],
        'last': value['last'],
        'numberOfElements': value['numberOfElements'],
        'empty': value['empty'],
    };
}

